import { AppLangSwitcher } from '@/features/AppLangSwitcher';
import IconSupport from '@/shared/assets/icons/icon-support.svg?react';
import { Button } from '@/shared/ui/shadcn/ui/button';
import { Stack } from '@/shared/ui/Stack/Stack';
import { AppUserProfile } from '../AppUserProfile/AppUserProfile';
import { PageBreadcrumbs } from '../PageBreadcrumbs/PageBreadcrumbs';

export const AppNavbar = () => {
  return (
    <div className="bg-background sticky top-0 z-20 flex items-center justify-between px-7 py-6">
      <PageBreadcrumbs />
      <Stack
        direction="horizontal"
        className="flex-shrink-0 items-center justify-between gap-x-15"
      >
        <Stack direction="horizontal" className="items-center gap-x-7">
          <Button variant="ghost" size="icon" asChild>
            <a
              className="block"
              href="https://t.me/openbiznes_support"
              target="_blank"
            >
              <IconSupport className="text-grey-4d5761 size-6" />
            </a>
          </Button>
          <AppLangSwitcher
            chevronClassnames="text-grey-6c737f"
            className="border-grey-f3f4f6 bg-grey-f3f4f6 shadow-none"
          />
        </Stack>
        <AppUserProfile />
      </Stack>
    </div>
  );
};
